import React from 'react';

import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

interface ImageLightboxModelProps {
  isOpen: boolean;
  onClose: () => void;
  src: string;
  alt: string;
}

const ImageLightboxModel = ({
  isOpen,
  onClose,
  src,
  alt,
}: ImageLightboxModelProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="6xl">
      <ModalOverlay />

      <ModalContent
        maxW="95vw"
        maxH="95vh"
        overflow="hidden"
        borderRadius="8px"
      >
        <ModalCloseButton />

        <ModalBody padding="20px">
          <Flex
            width="100%"
            height="85vh"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
              height="100%"
            >
              <Image
                src={src}
                alt={alt}
                objectFit="contain"
                maxW="90vw"
                maxH="85vh"
                minW="70vw"
                minH="70vh"
                borderRadius="6px"
              />
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ImageLightboxModel;